import { UserModulesAccessState } from "../types/types";
import { USER_ACCESS_MENU_LINK_DATA_FAILURE, USER_ACCESS_MENU_LINK_DATA_REQUEST, USER_ACCESS_MENU_LINK_DATA_SUCCESS } from "./actionTypes";


const userModulesAccessState: UserModulesAccessState = {
    menuLinks: {
        loading: false,
        data: []
    }
};

export default (state = userModulesAccessState, action: { type: string; payload: any }) => {
    switch (action.type) {
        case USER_ACCESS_MENU_LINK_DATA_REQUEST:
            return {
                ...state,
                menuLinks: {
                    data: [],
                    loading: true,
                },
            };
        case USER_ACCESS_MENU_LINK_DATA_SUCCESS:
            return {
                ...state,
                menuLinks: {
                    data: action?.payload??[],
                    loading: false,
                },
            };
        case USER_ACCESS_MENU_LINK_DATA_FAILURE:
            return {
                ...state,
                menuLinks: {
                    data: action?.payload??[],
                    loading: false,
                },
            };

        default:
            return {
                ...state,
            };
    }
};